import { SidenavService } from 'src/app/services/sidenav.service';
import { OverviewService } from './../services/overview.service';
import { AppStateProvider } from './../services/app-state.provider';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { CommonService } from '../services/common.service';
import { environment } from 'src/environments/environment';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';

export class OverviewData {
  companiesEnrolled: number;
  claCreditPoint: number;
  complimentaryActiveCreditPoints: number;
  complimentarySoldCreditPoints: number;
  employeesCheckedIn: number;
  employeesEnrolled: number;
  meetingRoomsBookedToday: number;
  meetingRoomsBookedTodayDuration: number;
  fourWheelParkings: number;
  twoWheelParkings: number;
}

@Component({
  standalone: false,
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  meetingNav;
  hover: boolean = false;
  isDisplay: any;
  index: any;
  changeText: boolean;
  changeEmployeeText: boolean;
  changeEmployeeCheckedText: boolean;
  changeDayPassText: boolean;
  changeCompliCredit: boolean;
  changeClaCredit: boolean;
  changeMeetingRoomsText: boolean;
  changeParkingText: boolean;
  overviewData = new OverviewData();
  tokens: any;

  constructor(
    private sideNavService: SidenavService,
    // private adalService: MsAdalAngular6Service,
    private commonService: CommonService,
    private route: Router,
    private appStateSrv: AppStateProvider,
    private overviewSrv: OverviewService,
    private router: Router,
    private authService: MsalService, // newly added
  ) {
    this.appStateSrv.setLoginStatus(true);
    // if (this.adalService.isAuthenticated) {
    //   this.appStateSrv.setLoginStatus(true);
    // }
    // this.getAdminForCheckinToken();
    let checkRoute = localStorage.getItem('userType');
    if (checkRoute == 'Parkite') {
      this.route.navigateByUrl('parkite-overview');
    }
  }

  ngOnInit(): void {
    this.getAdminForCheckinToken();
    this.reloadCurrentRoute();
    // this.getOverviewData(); //closed for token
    // this.meetingNav = [
    //   {
    //     index: "0",
    //     name: "Overview",
    //     link: '/overview'
    //   }
    // ]

    // const route = {
    //   index: "0",
    //   name: "Overview",
    //   link: '/overview'
    // };
    const route = this.sideNavService.routingChunks({ name: 'Overview' });

    this.appStateSrv.setSideNavState(route);
    // const customUrl=(this.id)?`edit-faq/${this.id}`:`add-faq`
  }

  getAdminForCheckinToken() {
    this.getParkbyClaId();
    // console.log("in overview page");
    // let emailAddress = localStorage.getItem('loginemailaddress');
    // this.commonService.getAdminTokenInOverviewPage(emailAddress).subscribe(r => {
    //   this.tokens = JSON.parse(localStorage.getItem('Tokens'));
    //   this.commonService.setTokenAfterSelectionForOverViewPage(this.tokens[1]);
    //   this.getParkbyClaId();
    //   // location.reload();
    // });
  }

  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe((res) => {
      // console.log(res);
      if (res.isValid) {
        if (localStorage.getItem('parkId')) {
          // if (res.list[0].locationId) {
          //   localStorage.setItem('locationId', res.list[0].locationId);
          // } else {
          //   localStorage.setItem('locationId', '1');
          // }
        } else {
          localStorage.setItem('parkId', res.list[0].parkId);
        }
        if (localStorage.getItem('locationId') == '' || localStorage.getItem('locationId') == 'null' || localStorage.getItem('locationId') == null) {
          localStorage.setItem('locationId', res.list[0].locationId);
        }
        // console.log('parkId', res.list[0].parkId)
        // localStorage.setItem('parkId', res.list[0].parkId);
        localStorage.setItem('parkDropDownDetails', JSON.stringify(res.list));
        this.getOverviewData();
      }
    });
  }

  changeImage() {
    this.hover = !this.hover;
  }
  mouseEnter(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  mouseLeave(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  getAdmin() {
    // this.commonService
    //   .getAdminToken(this.adalService.LoggedInUserEmail)
    //   .subscribe((r) => {
    //     if (r.isValid == false) {
    //       this.route.navigateByUrl('');
    //     }
    //   });

    this.commonService
      .getAdminToken(localStorage.getItem('userEmail'))
      .subscribe((r) => {
        if (r.isValid == false) {
          this.logoutFromCla();
          // this.route.navigateByUrl('');
        }
      });
  }

  getOverviewData() {
    // let overviewData: any = null
    this.overviewSrv.getOverViewData().subscribe((response) => {
      console.log('response overview ', response);

      this.overviewData.companiesEnrolled = response.data.companiesEnrolled;
      this.overviewData.claCreditPoint = response.data.claCreditPoint;
      this.overviewData.complimentaryActiveCreditPoints =
        response.data.complimentaryActiveCreditPoints;
      this.overviewData.complimentarySoldCreditPoints =
        response.data.complimentarySoldCreditPoints;
      this.overviewData.employeesCheckedIn = response.data.employeesCheckedIn;
      this.overviewData.employeesEnrolled = response.data.employeesEnrolled;
      this.overviewData.meetingRoomsBookedToday =
        response.data.meetingRoomsBookedToday;
      this.overviewData.meetingRoomsBookedTodayDuration =
        response.data.meetingRoomsBookedTodayDuration;
    });
    this.overviewSrv.getDayPass().subscribe((response) => {
      console.log('response getDayPass ', response);
    });
    this.overviewSrv.getParkingData().subscribe((response) => {
      console.log('response ovegetParkingDatarview ', response);
      this.overviewData.fourWheelParkings = response.data.fourWheelParkings;
      this.overviewData.twoWheelParkings = response.data.twoWheelParkings;
    });
  }

  routeToMeetingReport() {
    const fromDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const toDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const queryParams = {
      type: 4,
      fromDate: fromDate,
      toDate: toDate,
      select: 'All',
    };
    console.log('queryParams', queryParams);

    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/reports']);
  }

  reloadCurrentRoute() {
    if (!localStorage.getItem('foo')) {
      localStorage.setItem('foo', 'no reload');
      location.reload();
    }
  }

  logoutFromCla() {
    setTimeout(() => {
      this.logoutFromAd();
    }, 10000);
  }

  logoutFromAd(popup?: boolean) {
    // if (popup) {
    //   this.authService.logoutPopup({
    //     mainWindowRedirectUri: environment.domain + '/' // "http://localhost:4200/"
    //   });
    // } else {
    //   this.authService.logoutRedirect();
    // }
    window.location.href=`https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }
}
